module.exports = __webpack_public_path__ + "img/logo.141a4da8.png";